import { IncomingMessage } from "http";
import { RequestContext } from "asosteam";
import {
  getCountry,
  getKeyStoreDataversion,
  getPlatform,
  getShop,
  getVersionManifest,
  getStoreUrl,
} from "@repo/sitecore-lib/store-presentation";

export const getRequestContext = async (
  req: IncomingMessage,
): Promise<RequestContext> => {
  const [
    countryData,
    keyStoreDataversion,
    platform,
    shop,
    versionManifest,
    defaultStoreUrl,
    menStoreUrl,
    myAccountStoreUrl,
    secureStoreUrl,
    womenStoreUrl,
  ] = await Promise.all([
    getCountry(req),
    getKeyStoreDataversion(req),
    getPlatform(req),
    getShop(req),
    getVersionManifest(req),
    getStoreUrl({ type: "default", req }),
    getStoreUrl({ type: "men", req }),
    getStoreUrl({ type: "my-account", req }),
    getStoreUrl({ type: "secure", req }),
    getStoreUrl({ type: "women", req }),
  ]);

  const requestContext: RequestContext = {
    countryData,
    keyStoreDataversion,
    shop,
    storeCode: countryData.storeCode,
    countryCode: countryData.countryCode,
    currency: countryData.defaultCurrency,
    lang: countryData.defaultLanguage,
    platform,
    storeUrls: {
      default: defaultStoreUrl,
      men: menStoreUrl,
      myAccount: myAccountStoreUrl,
      secure: secureStoreUrl,
      women: womenStoreUrl,
    },
    versionManifest,
  };

  return requestContext;
};
